
export const Constants = {
	DATE_TIME_FORMAT: 'YYYY-MM-DD HH:mm:ss',
	DATE_FORMAT: 'YYYY-MM-DD',
	DATE_FORMAT_GET: 'YYYY-MM-DD',
	DATE_TIME_FORMAT_GET: 'YYYY-MM-DDTHH:mm:ssZ',

	//format daty dla komponentu Calendar
	DATE_FORMAT_CALENDAR: 'yy-mm-dd',
	MAX_RECORDS_FOR_REPORT: 5000,
}